import { useEffect } from 'react';
import Image from 'next/image';
import logo from '@public/assets/logo.svg';
import { Typography } from 'antd';
import styled from 'styled-components';

import { PC } from '@/_pages/types';
import { ContainerBG } from '@/shared/components';
import { Container, Row } from '@/shared/components/layout';
import { COLORS } from '@/shared/constants/colors';
import { useRegistrationStore } from '@/shared/store/registration.store';

import appInfo from '../../../../app-info.json';

import { LoginDefault } from './components/LoginDefault';

type IndexPageProps = {
  beneficiaryJWT: string | undefined;
};

export const PageRoot: PC<IndexPageProps> = ({ beneficiaryJWT }) => {
  const { setBeneficiaryJWT } = useRegistrationStore();

  useEffect(() => {
    setBeneficiaryJWT(beneficiaryJWT);
  }, []);

  return (
    <RowStyled justifyContent={'center'}>
      <Container maxWidth={390} width={'100%'} paddingY={10}>
        <Row direction="column" alignCenter height="100%">
          <Container
            paddingX={30}
            width="100%"
            style={{ display: 'flex', justifyContent: 'center' }}
          >
            <Image src={logo} alt="logo" width={150} height={96} />
          </Container>

          <Container marginTop={32}>
            <ContainerBG>
              <LoginDefault beneficiaryJWT={beneficiaryJWT} />
            </ContainerBG>
          </Container>
          <Container marginTop={24} width="100%" textCenter>
            <Typography.Text style={{ opacity: 0.1 }}>v {appInfo.version}</Typography.Text>
          </Container>
        </Row>
      </Container>
    </RowStyled>
  );
};

const RowStyled = styled(Row)`
  height: 100dvh;
  background-color: ${COLORS.colorBgLayout};
`;
